import { PlatformPrivateServices } from '@wix/editor-platform-private-api';
import { ApplicationSpecExtractor } from './types';
import { IApplicationSpec } from '../../types';

// TODO: re-implement it as a part of the abstraction over ClientSpecMap
// Jira task: https://jira.wixpress.com/browse/EP-3788
export class ApplicationSpecExtractorComposite {
  private extractors: ApplicationSpecExtractor[] = [];

  constructor(private ps: PlatformPrivateServices) {
    this.ps = ps;
  }

  public with(extractor: ApplicationSpecExtractor): this {
    this.extractors.push(extractor);
    return this;
  }

  public execute(): IApplicationSpec[] {
    const installedApps = this.ps.ds.platform.getInstalledApps();

    return installedApps.flatMap((app) =>
      this.extractors.flatMap((extractor) => extractor.extract(app)),
    );
  }
}
